import { createClient } from '@supabase/supabase-js';

// ─────────────────────────────────────────────────────────────────
// SUPABASE CONNECTION
// Replace the two values below with your real credentials from:
// supabase.com → Your Project → Settings → API
// ─────────────────────────────────────────────────────────────────

const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON) {
  console.error(
    '⚠️ Supabase credentials missing. ' +
    'Create a .env file in your project root with REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.'
  );
}

export const supabase = createClient(
  SUPABASE_URL  || '',
  SUPABASE_ANON || ''
);